import Preloader from '../modules/components/preloader';
import Animation from '../modules/animation/animation';

import '../../scss/styles.scss';

function entry() {
  new Preloader('.site-preloader', 500, () => console.log('Page loaded'))
    .then(() => {
      new Animation({
        query: '.site-animation',
        defaultDelay: 150,
        titleQuery: '[data-animation="title"]',
      });
    });
}

document.addEventListener('DOMContentLoaded', entry);
